const initialState = {
  fields: {},
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case 'SET_FIELD_ERROR':
      return {
        ...state,
        fields: {
          ...state.fields,
          [payload.id]: {
            ...(state.fields[payload.id] || {}),
            [payload.errorType]: payload.errorValue,
          },
        },
      };
    case 'REMOVE_FIELD_ERROR':
      return {
        ...state,
        fields: {
          ...state.fields,
          [payload.id]: {
            ...(state.fields[payload.id] || {}),
            [payload.errorType]: null,
          },
        },
      };
    case 'CLEAR_FIELD_ERROR':
      return {
        ...state,
        fields: Object.keys(state.fields).reduce((acc, key) => {
          if (key !== payload.id) {
            acc[key] = state.fields[key];
          }
          return acc;
        }, {}),
      };
    default:
      return state;
  }
}
